<template>
     <el-dialog
     :title="title"
     :visible.sync="dialogVisible"
     width="400px"
     top="5vh"
    :show-close="true"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    :destroy-on-close="true"
    @close="closeDialog"
    >
       <div class="panel">
           <el-form ref="form" :model="form" :rules="formRules" label-width="80px">
                <el-row :gutter="5">
                    <el-col :span="24">
                        <el-form-item label="姓名" prop="name">
                            <el-input size="small" v-model="form.name" disabled placeholder="输入姓名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="账号" prop="account">
                            <el-input size="small" v-model="form.account" disabled placeholder="输入账号"></el-input>
                        </el-form-item>
                    </el-col>
                 
                    <el-col :span="24"> 
                        <el-form-item label="新密码" prop="passwordNew">
                            <el-input size="small" placeholder="请输入新密码" v-model="form.passwordNew" show-password></el-input>
                        </el-form-item>
                    </el-col>
                     <el-col :span="24"> 
                        <el-form-item label="确认密码" prop="passwordConfirm">
                            <el-input size="small" placeholder="请输入新密码" v-model="form.passwordConfirm" show-password></el-input>
                        </el-form-item>
                    </el-col>
                   

                </el-row>
           </el-form>

           
       </div>
       <div class="panel-bottom">
            <el-button size="small" type="default"  @click="closeDialog">取消</el-button>
            <el-button size="small" type="primary"  @click="handleSave">确认</el-button>
        </div>
     
    </el-dialog>
</template>
<script>
export default {
    name:'resetPwd',
    props:{ 
        diaVisible:{
            type:Boolean,
            default:false,
        },
        rowData:{
            type:Object,
            default:{},
        },

    },
    watch:{
        diaVisible(newVal,oldVal){
            if(newVal){
                this.dialogVisible = newVal;
            }
        },
        rowData(newVal,oldVal){
            if(JSON.stringify(newVal) != "{}"){

                this.form = JSON.parse(JSON.stringify(newVal));
            }else{
                
                this.form = {};
            }
        }
    },
    data(){
        var validatePass = (rule, value, callback) => {
            if (!value || value == null || value.trim() == '') {
                callback(new Error('请输入密码'));
            } else {
                setTimeout(() => {
                    if (this.form.passwordNew !== '') {
                            
                        this.$refs.form.validateField('passwordNew');
                    }
                });
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (!value || value == null || value.trim() == '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.form.passwordNew) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return{
            title:'修改密码',
            dialogVisible: false,
            form:{
            },
            formRules:{
                passwordNew:[
                    {
                        required: true, validator: validatePass, trigger: ['change','blur']
                    }
                ],
                passwordConfirm:[
                    {
                        required: true, validator: validatePass2, trigger: ['change','blur']
                    }
                ],
            },
         
        }
    },
    created(){
        
    },
    methods:{
        handleSave(){
             this.$refs["form"].validate((valid) => {
                 
                if (valid) {
                    this.dialogVisible = false;
                    this.$emit('save',this.form);
                }
             })
            
        },
      
        closeDialog(){
            this.$refs.form.resetFields();
            this.dialogVisible = false;
            this.$emit('close');
            // setTimeout(() => {
            //     this.$parent.createProductPanVisible = false;
            // }, 100);
        },
       
    }
    
}
</script>
<style scoped>
    .panel{
        /* width: 100%; */
        height: auto;
        max-height: 250px;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 0px 10px;
    }
   
    .panel-bottom{
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding-top: 20px;
        text-align: center;
    }
    .panel-bottom el-button{
        margin: 10px 0 0 10px;
    }
   
</style>



// WEBPACK FOOTER //
// src/views/systemSetting/userSys/resetPwd.vue